module.exports = __webpack_public_path__ + "img/code2.343a51c9.png";